import styles from './TimeWidget.module.scss'

export function TimeWidget({ currentTime, player = false }) {
	return <div className={`${styles.time_widget} ${player ? styles.player : ''}`}>{currentTime.format('HH:mm')}</div>
}

export default TimeWidget
